import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'number-only-input',
  templateUrl: './number-only.component.html',
  styleUrls: ['./number-only.component.scss']
})
export class NumberOnlyComponent implements OnInit {

  @Input() id!: string;
  @Input() formGroup!: FormGroup;
  @Input() placeholder!: string;
  @Input() label!: string;

  constructor() { }

  ngOnInit(): void {
  }

}
